import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Cart from '../../shop/Cart';
import LearningZoneShell, { useLearningZoneSidebar } from './LearningZoneShell';
import { LZ_SCROLL_REGION } from './LearningSidebar';

/**
 * The student's Shop pages (/shop, a product, checkout, My Orders, an order and
 * its receipt, and the shop's Transactions tab at /coins/history) inside the
 * Learning Zone frame instead of the old TitleBar/Toolbar layout: the top bar
 * (Shop highlighted, plus the cart) and the sidebar stay put, and the shop page
 * itself - the same page every other role gets - fills the main area as one card.
 * Picking a sidebar row goes back to the Learning Zone with that row open.
 */
export default function StudentShopLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { tree } = useLearningZoneSidebar();
  const mainRef = useRef(null);

  // At lg+ the main area scrolls on its own (not the window), so start each shop page at its top.
  useEffect(() => {
    if (mainRef.current) mainRef.current.scrollTop = 0;
  }, [pathname]);

  return (
    <LearningZoneShell
      sidebarTree={tree}
      activeView={null}
      onSelectView={(view) => navigate('/student/learning-zone', { state: { view } })}
      shopActive
    >
      <div ref={mainRef} className={`w-full flex-1 min-w-0 ${LZ_SCROLL_REGION}`}>
        {/* The card: the shop page fills it, and its full-window min-height (min-h-screen,
            meant for the old layout) gives way to the card's, so short pages don't scroll. */}
        <div className="min-h-full flex flex-col bg-slate-50 rounded-2xl shadow-sm border border-gray-100 overflow-clip [&>*]:flex-1 [&>*]:w-full [&>.min-h-screen]:min-h-0">
          <Outlet />
        </div>
      </div>

      {/* Cart drawer (opened from the top bar's cart button), as the old TitleBar had it. */}
      <Cart />
    </LearningZoneShell>
  );
}
